import axiosInstance from './httpClient';
import { isAuthed } from './helper';

const publicUris = [
  'login',
  'register',
  'send-reset-email',
  'reset-password',
  'resend-code',
  'is-admin',
  'impersonate',
];

export function apiGet(path) {
  const authToken = localStorage.getItem('authToken');
  const config = {
    timeout: 60000,
    headers: {
      Authorization: `Token ${authToken}`,
    },
  };

  return axiosInstance.get(path, config);
}
export function apiPost(path, data) {
  if (!isAuthed() && !publicUris.some((uri) => path.includes(uri))) {
    localStorage.removeItem('authToken');
    window.location.href = '/sign-in';
    return;
  }

  const authToken = localStorage.getItem('authToken');
  const config = {
    timeout: 60000,
    headers: {
      Authorization: `Token ${authToken}`,
    },
  };

  return axiosInstance.post(path, data, config);
}

export function apiPatch(path, data) {
  const authToken = localStorage.getItem('authToken');
  const config = {
    timeout: 60000,
    headers: {
      Authorization: `Token ${authToken}`,
    },
  };

  return axiosInstance.patch(path, data, config);
}

export function apiPut(path, data) {
  if (!isAuthed()) {
    localStorage.removeItem('authToken');
    window.location.href = '/sign-in';
    return;
  }

  const authToken = localStorage.getItem('authToken');
  const config = {
    timeout: 60000,
    headers: {
      Authorization: `Token ${authToken}`,
    },
  };

  return axiosInstance.put(path, data, config);
}

export function apiDelete(path, data) {
  const authToken = localStorage.getItem('authToken');
  const config = {
    timeout: 60000,
    headers: {
      Authorization: `Token ${authToken}`,
    },
  };

  return axiosInstance.delete(path, { ...config, ...data });
}

export default axiosInstance;
